export const delay = async (interval: number) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(null);
    }, interval);
  });
